'use client';

import React from 'react';
import { usePreloader } from '@/components/preloader/usePreloader';
import { Preloader } from '@/components/preloader/Preloader';

export default function ClientLayoutWrapper({ children }: { children: React.ReactNode }) {
  const { loading, setLoading } = usePreloader();

  return (
    <>
      {/* 
        By conditionally rendering the preloader here, when loading is false, 
        the Preloader container AND the NoiseOverlay SVG filter are completely 
        purged from the DOM, leaving zero residual filters or layers.
      */}
      {loading && (
        <Preloader onComplete={() => setLoading(false)} />
      )}
      
      <div 
        className={`transition-opacity duration-1000 ease-out ${
          loading ? 'opacity-0 pointer-events-none' : 'opacity-100'
        }`}
      >
        {children}
      </div>
    </>
  );
}